import script from "./chooseWxGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./chooseWxGroup.vue?vue&type=script&setup=true&lang=js"

import "./chooseWxGroup.vue?vue&type=style&index=0&id=055d880c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-055d880c"]])

export default __exports__